// src/utils/whiteboardLogic.js
export function determineWhiteboardMode({
  userLockedWhiteboard,
  roomLockedWhiteboard,
  isAdmin,
  isPresenter,
  isUserRecorder,
}: {
  userLockedWhiteboard?: boolean;
  roomLockedWhiteboard?: boolean;
  isAdmin?: boolean;
  isPresenter?: boolean;
  isUserRecorder?: boolean;
}): boolean {
  const isUserWhiteboardAllowed = !userLockedWhiteboard;
  const isRoomWhiteboardAllowed = !roomLockedWhiteboard;
  const isParticipant = !isAdmin;

  // If the user is a recorder bot, enable view-only mode
  if (isUserRecorder) {
    return true; // View-only mode
  }

  // If the user is a presenter, to be Edit mode and add preloaded library items
  if (isPresenter) {
    return false; // Edit mode
  }

  // If the user is an admin and the whiteboard is not locked for the user, to be Edit mode
  if (isAdmin && isUserWhiteboardAllowed) {
    return false; // Edit mode
  }

  // If the user is a participant and the whiteboard is not locked for the (room or user), to be Edit mode
  if (isParticipant && isRoomWhiteboardAllowed && isUserWhiteboardAllowed) {
    return false; // Edit mode
  }

  // Default to view-only mode
  return true; // View-only mode
}
